<template>
  <div class="row justify-content-center">
    <div class="col-lg-6 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <b-modal hide-footer title="Olvidé mi contraseña" size="lg" v-model="modals.modal1">
          <div class="row">
            <base-input class="mb-3 ml-3 mr-3"
                        placeholder="Correo electrónico"
                        addon-left-icon="ni ni-email-83"
                        v-model="email_reset">
            </base-input>
          </div>

          <div>
            <base-button
              type="success"
              @click="resetPassword()"
            >Restablecer mi contraseña</base-button>
          </div>
          
        </b-modal>
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <h2>Inicia sesión</h2>
          </div>
          <!-- +52<input type="number" v-model="phNo" placeholder="Phone Number"/>
            <button @click="sendOtp">Get OTP</button>
            <div id="recaptcha-container"></div><br>
            <input type="number" v-model="otp" placeholder="OTP"/>
            <button @click="verifyOtp">Verify</button><br>
            <button @click="sendOtp">Resend OTP</button> -->
          <form role="form">
            <div class="d-flex align-items-center mb-3">
              <base-input 
                  v-model="codigoPais"
                  class="m-0 input-group-alternative mr-3"
                  addon-left-icon="ni ni-fat-add"
                  type="number"
                  min="1"
                  style="width: 140px;"
              />
              <base-input class="input-group-alternative mb-0"
                placeholder="Teléfono registrado (10 dígitos)"
                type="number"
                addon-left-icon="fa fa-mobile"
                v-model="phNo">
              </base-input>
          </div>

            <base-input class="input-group-alternative mb-3"
              placeholder="RFC"
              addon-left-icon="ni ni-badge"
              v-model="usuario.rfc">
            </base-input>

            <base-input class="input-group-alternative"
              v-if="sentSMS"
              placeholder="Codigo SMS"
              type="text"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="otp">
            </base-input>
            <div id="recaptcha-container"></div>
            <div class="text-left">
              <base-button type="primary" size="sm" outline v-if="sentSMS" @click="sendOtp">Reenviar SMS</base-button>
              <!-- <base-button type="primary" class="my-4" @click="login" v-if="!soyClienteSinContraseña">Entrar</base-button> -->
            </div>
            

            <div class="text-center">
              <base-button type="primary" class="my-4" v-if="!sentSMS" @click="sendOtp">Enviar SMS</base-button>
              <base-button type="primary" class="my-4" v-if="sentSMS" @click="verifyOtp">Entrar</base-button>
              <!-- <base-button type="primary" class="my-4" @click="login" v-if="!soyClienteSinContraseña">Entrar</base-button> -->
            </div>
            <div class="text-center">
              <!-- <base-button type="primary" class="my-4" @click="createPassword" v-if="soyClienteSinContraseña">Entrar</base-button> -->
            </div>
            <!-- <div class="text-center">
              <base-button type="primary" outline class="my-1" v-if="soyClienteSinContraseña" @click="soyClienteSinContraseña = false">Ya soy cliente y si tengo contraseña</base-button>
            </div>
            <div class="text-center">
              <base-button type="primary" outline class="my-1" v-if="!soyClienteSinContraseña" @click="soyClienteSinContraseña = true">Ya soy cliente y no tengo contraseña</base-button>
            </div> -->
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
            <!-- <a href="#" @click="modals.modal1 = true" class="text-light"><small>¿Olvidaste tu contraseña?</small></a> -->
        </div>
        <div class="col-6 text-right">
            <router-link to="/register" class="text-white"><small>Registrate aquí</small></router-link>
        </div>
    </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  name: "login",
  data() {
    return {
      usuario: {
        email: "",
        rfc:"",
        password: "",
      },
      modals:{
        modal1:false
      },
      email_reset:null,
      soyClienteSinContraseña: false,
      phNo: '',
      appVerifier : '',
      otp : '',
      sentSMS:false,
      codigoPais: '52'
    };
  },
  created(){
    this.initReCaptcha()
  },
  methods: {
    sendOtp(){
        if(this.phNo.length != 10){
          alert('Invalid Phone Number Format !');
        }else{
          //
          let countryCode = this.codigoPais ? `+${this.codigoPais}` : '+52' //Mexico
          let phoneNumber = countryCode + this.phNo
          //
          let appVerifier = this.appVerifier
          //
          firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
            .then((confirmationResult) => {
              // SMS sent. Prompt user to type the code from the message, then sign the
              // user in with confirmationResult.confirm(code).
              window.confirmationResult = confirmationResult;
              this.sentSMS = true
              //
              alert('SMS sent')
            }).catch((error) => {
              // Error; SMS not sent
              alert('Error: ' + error)
            });
        }
      },
      //
      verifyOtp(){
        if(this.phNo.length != 10 || this.otp.length != 6){
          alert('Invalid Phone Number/OTP Format !');
        }else{
          //
          let vm = this
          let code = this.otp
          //
          window.confirmationResult.confirm(code).then((result) =>{
            // User signed in successfully.
            console.log(result)
            var user = result.user;
            fetch("https://api.lb.canplast.net/api/business_part/"+this.usuario.rfc, {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            })
            .then((response) => response.json())
            .then((responseJson) => {
              console.log(responseJson.value[0])
              if(responseJson.value[0] === 'empty' || !responseJson.value[0]){
                alert("Este numero y RFC no coinciden en el sistema, por favor verificalo con tu agente de ventas")
                firebase.auth().signOut().then(() => {
                  this.$router.replace('login')
                })
              }
              else{
                if(responseJson.value[0].ContactEmployees.find((x) => x.Name === 'Acceso a Plataforma').Phone1 === this.phNo){
                  localStorage.setItem("rfc", this.usuario.rfc);
                  localStorage.setItem("phone", this.phNo);
                  this.$router.replace("inicio"); 
                }
                else{
                  alert("Este numero y RFC no coinciden en el sistema, por favor verificalo con tu agente de ventas")
                  firebase.auth().signOut().then(() => {
                    this.$router.replace('login')
                  })
                }
              }
            })
            .catch((error) => {
              console.error(error);
            });
            // ...
            //route to set password !
            //vm.$router.push({path:'/setPassword'})
          }).catch(function (error) {
            // User couldn't sign in (bad verification code?)
            // ...
          });
        }
      },
      initReCaptcha(){
        setTimeout(()=>{
          let vm = this
          window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': function(response) {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              // ...
            },
            'expired-callback': function() {
              // Response expired. Ask user to solve reCAPTCHA again.
              // ...
            }
          });
          //
          this.appVerifier =  window.recaptchaVerifier
        },1000)
      },


    resetPassword(){
      if(this.email_reset){
        firebase
          .auth()
          .sendPasswordResetEmail(this.email_reset)
          .then(function () {
            alert("El restablecimiento de contraseña se ha enviado a tu correo electrónico");
          })
          .catch(function (error) {
            alert(error);
          });
      }
      else{
        alert("Por favor teclea tu correo electrónico")
      }
    },
    createPassword(){
      if(this.usuario.email && this.usuario.rfc){
        fetch("https://canplast.net:51000/api/v1/sap/GET/findCustomerByRFC/"+this.usuario.rfc+"/"+this.usuario.email, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => response.json())
        .then((responseJson) => {
          console.log(responseJson)
          if(responseJson[0] === 'empty'){
            alert("Este correo y RFC no coinciden en el sistema, por favor verificalo con tu agente de ventas")
          }
          else{
            //Send Email
            console.log("Arre")
            var email = "alfredoreyes.dev@gmail.com"
            if(this.usuario.email !== 'mueblesfutura@gmail.com'){
              email = this.usuario.email
            }
            firebase
            .auth()
            .createUserWithEmailAndPassword("alfredoreyes.dev@gmail.com", this.usuario.password)
            .then((result) => {
                console.log(result)
                localStorage.setItem("rfc", this.usuario.rfc);
                localStorage.setItem("email", this.usuario.email);
                this.$router.replace("inicio");
            }).catch(function(error) {
              // Handle Errors here.
              var errorCode = error.code;
              var errorMessage = error.message;
              alert("Este correo electrónico ya esta registrado en el sistema")
              console.log(errorCode);
              console.log(errorMessage);
            });

          }
        })
        .catch((error) => {
          console.error(error);
        });
      }
      else{
        alert("Por favor rellena todos los campos")
      }
    },
    login() {
      var email = ''
      if(this.usuario.email === 'mueblesfutura@gmail.com'){
        email = 'alfredoreyes.dev@gmail.com'
      }
      firebase.auth().signInWithEmailAndPassword(email, this.usuario.password).then((result) => {
        console.log(result)
        //Buscar por RFC y correo
        if(email === 'alfredoreyes.dev@gmail.com'){
          this.usuario.email = 'mueblesfutura@gmail.com'
        }
        console.log("https://canplast.net:51000/api/v1/sap/GET/findCustomerByRFC/"+this.usuario.rfc+"/"+this.usuario.email)
        fetch("https://canplast.net:51000/api/v1/sap/GET/findCustomerByRFC/"+this.usuario.rfc+"/"+this.usuario.email, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => response.json())
        .then((responseJson) => {
          console.log(responseJson)
          if(responseJson[0] === 'empty'){
            alert("Este correo y RFC no coinciden en el sistema, por favor verificalo con tu agente de ventas")
          }
          else{
            localStorage.setItem("rfc", this.usuario.rfc);
            localStorage.setItem("email", this.usuario.email);
            this.$router.replace("inicio");
          }
        })
        .catch((error) => {
          console.error(error);
        });

        /* firebase
        .auth()
        .signOut()
        .then(() => {
          alert("Solo las cuentas de @canplast.com.mx pueden acceder");
        }); */
      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        alert("Este correo electrónico no fue encontrado en el sistema o la contraseña es incorrecta")
        console.log(errorCode);
        console.log(errorMessage);
      });

    },
  },
};
</script>
<style>
</style>
